import { render, staticRenderFns } from "./DisplayCoupons.vue?vue&type=template&id=60c66565&scoped=true&"
import script from "./DisplayCoupons.vue?vue&type=script&lang=js&"
export * from "./DisplayCoupons.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCoupons.vue?vue&type=style&index=0&id=60c66565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c66565",
  null
  
)

export default component.exports